import Spinner from './spinner';

export * from './spinner';

export default Spinner;
